exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.full-height[data-v-5eddacac] {\n    height: 80vh;\n}\n.flex-center[data-v-5eddacac] {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n.position-ref[data-v-5eddacac] {\n    position: relative;\n}\n\n", ""]);

// exports
